import {LANGUAGE_ABBREVATION} from "../../locales/locales";
import {allInternationalPhonePrefixesFormattedForDropdownAlpha2CountryCode} from "../../components/settings/utils";
import {UserPreferencesProps} from "./userPreferences";
import {ScrollDirection} from "./common";
import {SortElementProps} from "atmosfair-ui";

export interface PersonalUserInformation {
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    internationalPhonePrefix: keyof typeof allInternationalPhonePrefixesFormattedForDropdownAlpha2CountryCode,
}

export interface UserProps extends PersonalUserInformation {
    id: string,
    termsAndConditionsAccepted: boolean,
    language: string,
    agencyIds: number[],
    companyId: number | null,
    userPreferences: UserPreferencesProps
    registrationComplete: boolean,
    isKlimaLink: boolean,
    deactivated: boolean
}

export interface WindowedUserAgenciesAdminOf {
    id: number,
    name: string
}

export interface WindowedUserProps extends PersonalUserInformation {
    id: string,
    isKlimaLinkAdmin: boolean,
    isCompanyAdmin: boolean,
    agenciesAdminOf: WindowedUserAgenciesAdminOf[],
    agencyIds: number[],
    registrationComplete: boolean,
    companyName: string | null,
    deactivated: boolean
}

export interface ReadUsersWindowedRequest {
    scrollPosition: String | null,
    direction: ScrollDirection,
    size: number,
    sort: SortUsers,
    sortOrder: SortElementProps["active"],
    searchTerm: string | null,
}

export enum SortUsers {
    firstName = "firstname",
    lastName = "lastname",
    email = "email",
    companyName = "companyname"
}

export interface WindowedUsersResponse {
    users: WindowedUserProps[];
    nextPosition: string | null;
    usersCount: number;
    companiesCount: number;
}

export interface ChangeUsersAgencyRequest {
    oldAgencyId: number,
    newAgencyId: number,
    userEmail: string
}

export interface InviteCompanyAdminRequest {
    firstName: string,
    lastName: string,
    email: string,
    companyName: string,
    language: string,
    isMember: boolean,
}

export interface UserToInviteProps {
    firstName: string
    lastName: string,
    isAdmin: boolean,
    email: string,
    language: string,
}

export interface InviteUserRequest {
    users: UserToInviteProps[],
    agencyId: number
}

export interface DeleteUser {
    userEmail: string
}

export interface RemoveUserFromAgency {
    agencyId: number,
    userEmail: string
}

export interface UserAdminRequest {
    agencyId: number,
    userEmail: string,
}

export interface UserRequest {
    id?: string,
    firstName?: string,
    lastName?: string,
    email?: string,
    language?: LANGUAGE_ABBREVATION,
    phoneNumber?: string,
    internationalPhonePrefix?: keyof typeof allInternationalPhonePrefixesFormattedForDropdownAlpha2CountryCode,
    termsAndConditionsAccepted?: boolean,
    registrationComplete?: boolean,
    userPreferences?: UserPreferencesProps
}

